import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ typography }) => ({
  title: {
    fontWeight: typography.body1.fontWeight
  }
}));